import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';

const StripeLogo = React.lazy(() => import('./stripeLogo.svg?react'));

export default function StripeMark() {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        gap: 0.5,
      }}
    >
      <Typography>{t('checkout.powered-by')}</Typography>
      <Suspense fallback={null}>
        <StripeLogo />
      </Suspense>
    </Box>
  );
}
